import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "id", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import Icon from '../../Icon';
import { DialogContext } from '../Dialog';
import { Styled } from './Header.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useDialogContext = function useDialogContext() {
  return useContext(DialogContext);
};

var DialogHeader = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      id = _ref.id,
      customClassName = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useDialogContext = useDialogContext(),
      hasCloseButton = _useDialogContext.hasCloseButton,
      icon = _useDialogContext.icon,
      isModal = _useDialogContext.isModal,
      metadata = _useDialogContext.metadata,
      onClose = _useDialogContext.onClose,
      status = _useDialogContext.status,
      title = _useDialogContext.title;

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-dialog__header"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var statusIcon;

  switch (status) {
    case 'neutral':
      statusIcon = 'info-sign';
      break;

    case 'positive':
      statusIcon = 'tick-circle';
      break;

    case 'warning':
      statusIcon = 'warning-sign';
      break;

    case 'error':
      statusIcon = 'error';
      break;

    default:
      statusIcon = icon;
  }

  return _jsxs(Styled.DialogHeader, _objectSpread(_objectSpread({
    ref: ref,
    id: id,
    className: className
  }, rest), {}, {
    children: [(icon || statusIcon) && _jsx(Styled.StatusIcon, {
      children: _jsx(Icon, {
        size: 28,
        icon: icon ? icon : statusIcon
      })
    }), (title || metadata) && _jsxs(Styled.Title, {
      children: [metadata && _jsx(Styled.Metadata, {
        children: metadata
      }), title && _jsx(Styled.Heading, {
        children: title
      })]
    }), isModal && hasCloseButton && _jsx(Styled.CloseButton, {
      onClick: function onClick() {
        return onClose();
      },
      children: _jsx(Icon, {
        icon: "cross"
      })
    })]
  }));
});
export default DialogHeader;